//#region src/properties/resolveStayCardBadgeKind.ts
var e = 2, t = {
	guest_favorite: "guestFavorite",
	hidden_gem: "hiddenGem",
	popular_choice: null,
	building_reputation: null,
	new: null,
	none: null
}, n = (e) => (e.reviewStatus ? t[e.reviewStatus] : null) || (e.isExclusive ? "exclusive" : e.isBestPrice ? "bestPrice" : e.instantBooking ? "instant" : null), r = (e, t) => e.listingCount == null ? [] : t === "photo" || e.roomCount == null ? [{
	key: "card.options",
	count: e.listingCount
}] : [{
	key: "card.roomTypes",
	count: e.listingCount
}, {
	key: "card.rooms",
	count: e.roomCount
}], i = (e) => {
	let n = (e.reviewStatus ? t[e.reviewStatus] : null) ?? (e.isExclusive ? "exclusive" : null);
	if (e.listingCount != null) return {
		photo: n,
		chips: ["options"]
	};
	let r = [];
	return e.isBestPrice && r.push("bestPrice"), e.instantBooking && r.push("instant"), e.isNewArrival && r.push("newArrival"), {
		photo: n,
		chips: r.slice(0, 2)
	};
};
//#endregion
export { e as STAY_CARD_MAX_CHIPS, n as resolveStayCardBadgeKind, i as resolveStayCardRowBadges, r as stayCardOptionsParts };
